import { Middleware } from 'redux';
import { Location } from 'history';

import { history } from 'core/use-cases/utilities';

const pathnameLoggerMiddleware: Middleware = (store) => {
  let prevPathname = history.location.pathname;

  history.listen((location: Location) => {
    const nextPathname = location.pathname;
    prevPathname = nextPathname;

    store.dispatch({
      type: '@@updatePathname',
      payload: nextPathname,
    });
  });

  return (next) => (action) => {
    return next(action);
  };
};

export { pathnameLoggerMiddleware };
